import React, { useState, useEffect } from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import "./App.css"

const hostName = window.location.hostname.toString().replace(/^(docs-api).(.*)$/gi, "$2");

const baseUrl = (hostName.indexOf('localhost') + 1)
    ? 'http://api.new-log-system.loc/docs/v2/specs/'
    : `${window.location.protocol}//api.${hostName}/docs/v2/specs/`;

/**
 * Компонент навигации по тегам API
 */
function ApiNavigation({ tags, selectedTag, onSelectTag }) {
    return (
        <nav className="api-nav">
            <div className="api-nav-header">
                <h3>📚 API Документация</h3>
            </div>
            <ul className="api-nav-list">
                <li 
                    className={`api-nav-item ${selectedTag === 'master' ? 'active' : ''}`}
                    onClick={() => onSelectTag('master')}
                >
                    <span className="api-nav-icon">📋</span>
                    <span className="api-nav-label">Обзор</span>
                </li>
                <li 
                    className={`api-nav-item ${selectedTag === 'common' ? 'active' : ''}`}
                    onClick={() => onSelectTag('common')}
                >
                    <span className="api-nav-icon">📦</span>
                    <span className="api-nav-label">Компоненты</span>
                </li>
                <li className="api-nav-divider">
                    <span>Теги</span>
                </li>
                {tags.map(tag => (
                    <li 
                        key={tag}
                        className={`api-nav-item ${selectedTag === tag ? 'active' : ''}`}
                        onClick={() => onSelectTag(tag)}
                    >
                        <span className="api-nav-icon">🏷️</span>
                        <span className="api-nav-label">{tag}</span>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

/**
 * Компонент для отображения информации о файле
 */
function FileInfo({ fileName, tag }) {
    const getDisplayName = (name) => {
        const displayNames = {
            'master': '📋 Обзор API (master.json)',
            'common': '📦 Общие компоненты (common.json)',
        };
        
        if (displayNames[name]) {
            return displayNames[name];
        }
        
        return `🏷️ ${name.charAt(0).toUpperCase() + name.slice(1)} (api_${name}.json)`;
    };
    
    return (
        <div className="file-info">
            <span className="file-info-name">{getDisplayName(tag)}</span>
            <span className="file-info-path">{fileName}</span>
        </div>
    );
}

/**
 * Заголовок страницы
 */
function Header() {
    return (
        <header className="app-header">
            <div className="app-header-content">
                <h1>Витал Логистика — API v2</h1>
                <p>Модульная документация REST API</p>
            </div>
        </header>
    );
}

/**
 * Главный компонент приложения
 */
export default function App() {
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState('master');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Загружаем список тегов из master.json
    useEffect(() => {
        const masterUrl = `${baseUrl}master.json`;
        
        fetch(masterUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Не удалось загрузить master.json');
                }
                return response.json();
            })
            .then(data => {
                const tagFiles = data['x-tag-files'] || [];
                const tagNames = tagFiles.map(item => item.tag);
                setTags(tagNames);
                setLoading(false);
            })
            .catch(err => {
                console.error('Ошибка загрузки master.json:', err);
                // Если master.json недоступен, используем статичный список
                setTags([
                    'Auth', 'Carrier', 'Company', 'Consignor', 'CrossDock',
                    'Delivery', 'DistributionCenter', 'Driver', 'ForeignPartner',
                    'Inform', 'LegalEntity', 'Log', 'Notification', 'OrderDelivery',
                    'Permission', 'Report', 'Role', 'ShipperCompany', 'System',
                    'Trail', 'Truck', 'Unloading', 'User', 'ApproveOrder'
                ]);
                setLoading(false);
            });
    }, []);

    // Формируем URL для выбранного файла
    const getDocUrl = (tag) => {
        if (tag === 'master') {
            return `${baseUrl}master.json`;
        }
        if (tag === 'common') {
            return `${baseUrl}common.json`;
        }
        return `${baseUrl}api_${tag.toLowerCase()}.json`;
    };

    const currentDocUrl = getDocUrl(selectedTag);
    const currentFileName = selectedTag === 'master' 
        ? 'master.json' 
        : selectedTag === 'common' 
            ? 'common.json' 
            : `api_${selectedTag.toLowerCase()}.json`;

    if (loading) {
        return (
            <div className="app-loading">
                <div className="app-loading-spinner"></div>
                <p>Загрузка документации...</p>
            </div>
        );
    }

    return (
        <div className="app-container">
            <Header />
            <div className="app-content">
                <ApiNavigation 
                    tags={tags} 
                    selectedTag={selectedTag}
                    onSelectTag={setSelectedTag}
                />
                <main className="app-main">
                    <FileInfo fileName={currentFileName} tag={selectedTag} />
                    <div className="swagger-container">
                        <SwaggerUI 
                            key={currentDocUrl}
                            url={currentDocUrl}
                            docExpansion="list"
                            defaultModelsExpandDepth={1}
                            defaultModelExpandDepth={1}
                        />
                    </div>
                </main>
            </div>
        </div>
    );
}